export const CORE_CURRICULUMS = '/api/v1/core-curriculums';
